import domain from "@/environment";
import axios from "axios";

const state = {
  precarite: null,
  precarites: [],
  precariteRows: 0,
  precariteLoading: false,
};

const getters = {
  getLoadingPrecarite: (state) => state.precariteLoading,
  getPrecarite: (state) => state.precarite,
  getAllPrecarites: (state) => state.precarites,
  getTotalRowPrecarite: (state) => state.precariteRows,
};

const mutations = {
  DO_NOTHING() {},
  SET_PRECARITE_LOADING(state, payload) {
    state.precariteLoading = payload || false;
  },
  SET_PRECARITE(state, payload) {
    state.precarite = payload ? payload : null;
  },
  PUSH_PRECARITE(state, payload) {
    state.precarites.push(payload);
  },
  UPDATE_PRECARITE(state, payload) {
    for (let index = 0; index < state.precarites.length; index++) {
      if (state.precarites[index].id === payload.id) {
        state.precarites.splice(index, 1, payload);
        break;
      }
    }
  },
  DELETE_PRECARITE(state, payload) {
    state.precarites = state.precarites.filter(
      (item) => item.id !== payload.id
    );
  },
  UPDATE_PRECARITE_ROW(state, payload) {
    state.precariteRows = payload ? payload : 0;
  },
  SET_PRECARITES(state, payload) {
    state.precarites = payload ? payload : [];
  },
};

const actions = {
  async allPrecarites({ commit }, payload) {
    commit("SET_PRECARITE_LOADING", true);

    const params = {
      page: payload?.page,
      per_page: payload?.per_page,
      entreprise_id: payload?.entreprise_id,
      configId: payload?.configId,
      entrepriseId: payload?.entrepriseId,
      lib: payload?.lib,
      search: payload?.search,
    };
    try {
      const response = await axios.get(domain + "/precarites", {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
        params,
      });

      // Gérer les deux formats de réponse : paginé ou tableau direct
      let precaritesData = [];
      let totalRows = 0;

      if (response.data && response.data.data) {
        // Si c'est un tableau direct (comme dans votre exemple)
        if (Array.isArray(response.data.data)) {
          precaritesData = response.data.data;
          totalRows = response.data.data.length;
        } 
        // Si c'est une structure paginée
        else if (response.data.data.data && Array.isArray(response.data.data.data)) {
          precaritesData = response.data.data.data;
          totalRows = response.data.data.total || 0;
        }
      }

      commit("SET_PRECARITES", precaritesData);
      commit("UPDATE_PRECARITE_ROW", totalRows);
      commit("SET_PRECARITE_LOADING", false);
      return response.data;
    } catch (error) {
      commit("SET_PRECARITE_LOADING", false);
      throw error.response ? error.response.data.message : error.message;
    }
  },
  async precarite({ commit }, payload) {
    commit("DO_NOTHING");
    try {
      const response = await axios.get(domain + `/precarites/` + payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("SET_PRECARITE", response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data.message;
    }
  },
  async editPrecarite({ commit }, payload) {
    try {
      let id;
      let configId;
      if (payload instanceof FormData) {
        id = payload.get("id");
        configId = payload.get("configId");
      } else {
        id = payload.id;
        configId = payload.configId;
      }

      if (!id) {
        throw new Error("ID is required for editing precarite");
      }

      const headers = {
        Authorization: `Bearer ` + this.state.token,
      };

      if (payload instanceof FormData) {
        headers["Content-Type"] = "multipart/form-data";
      }

      const query = configId ? `?configId=${encodeURIComponent(configId)}` : "";
      const response = await axios.put(
        domain + `/precarites/` + id + query,
        payload,
        {
          headers: headers,
        }
      );

      commit("UPDATE_PRECARITE", response.data.data);
      return response.data.data;
    } catch (error) {
      throw error.response && error.response.data
        ? error.response.data.message
        : error.message;
    }
  },
  async storePrecarite({ commit }, payload) {
    try {
      const headers = {
        Authorization: `Bearer ` + this.state.token,
      };

      if (payload instanceof FormData) {
        headers["Content-Type"] = "multipart/form-data";
      }

      const response = await axios.post(domain + `/precarites`, payload, {
        headers: headers,
      });

      commit("PUSH_PRECARITE", response.data.data);
      commit("UPDATE_PRECARITE_ROW", state.precariteRows + 1);
      return response.data.data;
    } catch (error) {
      throw error.response && error.response.data
        ? error.response.data.message
        : error.message;
    }
  },
  async deletePrecarite({ commit }, payload) {
    commit("SET_PRECARITE_LOADING", true);
    try {
      await axios.delete(domain + `/precarites/` + payload.id, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("DELETE_PRECARITE", payload);
      commit("UPDATE_PRECARITE_ROW", state.precariteRows - 1);

      commit("SET_PRECARITE_LOADING", false);
      return true;
    } catch (error) {
      commit("SET_PRECARITE_LOADING", false);
      throw error.response.data.message;
    }
  },
};

export default { state, mutations, getters, actions };

